export const pickUpCode = (code?: string) => {
    const c = code?.replace(/[^a-z0-9]/gi, "").toUpperCase();
    const d = code;
    return (c?.length && c?.length > 4 || d?.length && d?.length > 4 ? [c?.slice(0, 4), "-", c?.slice(4)].join("") :
        c ?? "");
};
